<template>
    <Toast />
    <h1>Planowane wyłączenia - panel admina</h1>
    <PlannedOutageAdminSearchCriteria ref="plannedOutageAdminSearchCriteria" v-model="searchCriteria"
                                      @update:modelValue="search" @confirmDelete="deleteSelectedOutages" />
    <PlannedOutageAdminTable ref="plannedOutageAdminTable" :search-criteria="searchCriteria" />
</template>

<script>
    import Toast from "primevue/toast";
    import {SearchCriteria} from "@/utils/SearchCriteria";
    import PlannedOutageAdminSearchCriteria from "./components/PlannedOutageAdminSearchCriteria";
    import PlannedOutageAdminTable from "./components/PlannedOutageAdminTable";

    export default {
        name: "PlannedOutageAdminView",

        components: {
            PlannedOutageAdminSearchCriteria,
            PlannedOutageAdminTable,
            Toast,
        },

        data() {
            return {
                searchCriteria: this.getClearSearchCriteria(),
            };
        },

        beforeMount() {
            SearchCriteria.loadCriteria(this);
        },

        mounted() {
            if (this.$route.params.showToast === "show") {
                this.$toast.add({
                    severity: "success",
                    summary: "Zapisano dane planowanego wyłączenia",
                    life: 2500,
                });
                this.$route.params.showToast = "hide";
            }
        },

        methods: {
            search() {
                SearchCriteria.updateUrl(this);

                this.$refs.plannedOutageAdminTable.search();
            },

            createdBy() {
                this.$router.push({name: "plannedOutageAdminCreate"});
            },

            clear() {
                this.searchCriteria = this.getClearSearchCriteria();
            },

            getClearSearchCriteria() {
                return {
                    id: null,
                    outageStart: null,
                    outageEnd: null,
                    deleted: false,
                    page: {
                        limit: 10,
                        offset: 0,
                        sortField: null,
                        sortOrder: null,
                    },
                };
            },

            deleteSelectedOutages() {
                this.$refs.plannedOutageAdminTable.deleteSelectedOutages();
            },
        },
    };
</script>

<style lang="less" scoped>
</style>
